module.exports = __webpack_public_path__ + "img/Page-1 (3).f2b959a9.svg";